<template>
    <div v-if="showResult">
        <!-- 検索後の表示 -->
        <SearchInfo :items="searchInfoItems"></SearchInfo>
        <!-- 結果表示用コンポーネントの準備を待つ -->
        <div id="results_block">
            <div v-if="searchError">
                <el-icon :size="15" color="#f16868" class="el-icon-warning" />
                検索結果の取得に失敗しました。
            </div>
            <div v-else>
                <ResultSummary
                    v-if="!searchLoad && hits > 0"
                    :hits="hits"
                    :nowPage="resultSummaryPage"
                />
                <PaginationTop
                    v-if="!searchLoad && hits > 0"
                    :hitsTotal="hits"
                    :currentPageSize="per_page"
                    :nowpage="page"
                    @emittedhandleSizeChange="changedPageSize"
                    @emittedhadleCurrentChange="changedCurrentPage"
                    :sortingItems="sortingItems"
                    :sortSelect="sort"
                    @emittedSortChange="changedSorting"
                />
                <el-row>
                    <el-col :span="18">
                        <Suspense timeout="0">
                            <template #default>
                                <div>
                                    <div v-if="searchLoad">
                                        <i class="el-icon-loading"></i>
                                    </div>
                                    <div v-else-if="hits === 0">
                                        検索結果はありません
                                    </div>
                                    <AllResultList
                                        v-if="!searchLoad && hits > 0"
                                        :hits="hits"
                                        :results="results"
                                        :searchData="searchParams"
                                    />
                                    <PaginationBottom
                                        v-if="!searchLoad && hits > 0"
                                        :hitsTotal="hits"
                                        :currentPageSize="per_page"
                                        :nowpage="page"
                                        @emittedhadleCurrentChange="
                                            changedCurrentPage
                                        "
                                    />
                                </div>
                            </template>
                            <template #fallback>
                                <div>
                                    <i class="el-icon-loading"></i>
                                </div>
                            </template>
                        </Suspense>
                    </el-col>
                    <el-col :span="6">
                        <Suspense timeout="0">
                            <template #default>
                                <AllFacetContainer
                                    v-if="facetResetFlg && hits > 0"
                                />
                            </template>
                            <template #fallback>
                                <div>
                                    <i class="el-icon-loading"></i>
                                </div>
                            </template>
                        </Suspense>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
    <div v-else>
        <!-- 検索前の表示 -->
        <el-row>
            <el-col :span="18">
                <Suspense timeout="0">
                    <template #default>
                        <!-- お知らせコンポーネントの準備を待つ -->
                        <PageNewsList />
                    </template>
                    <template #fallback>
                        <div>
                            <i class="el-icon-loading"></i>
                        </div>
                    </template>
                </Suspense>
            </el-col>
            <el-col :span="6">
                <Suspense timeout="0">
                    <template #default>
                        <!-- ランキングコンポーネントの準備を待つ -->
                        <div>
                            <PageRanking formtype="all" rankingtype="KEYWORD">
                                <template v-slot:default="{ rank }">
                                    <a
                                        v-on:click="
                                            handleRankingSearch(rank.keyword)
                                        "
                                        >{{ rank.keyword }}</a
                                    >
                                </template>
                            </PageRanking>
                        </div>
                    </template>
                    <template #fallback>
                        <div>
                            <i class="el-icon-loading"></i>
                        </div>
                    </template>
                </Suspense>
            </el-col>
        </el-row>
        <Banners />
    </div>
</template>

<script>
import PageRanking from "@/components/pages/PageRanking.vue";
import PageNewsList from "@/components/pages/PageNewsList.vue";
import Banners from "../Banners.vue";

import SearchInfo from "../SearchInfo.vue";
import ResultSummary from "../ResultSummary.vue";
import AllResultList from "../AllResultList.vue";
import PaginationTop from "../PaginationTop.vue";
import PaginationBottom from "../PaginationBottom.vue";
import AllFacetContainer from "./AllFacetContainer.vue";

import { SearchKey } from "../../composables/useAllSearch.js";

import { defineComponent, reactive, ref, watch, inject } from "vue";

export default defineComponent({
    components: {
        PageRanking,
        PageNewsList,
        Banners,
        SearchInfo,
        ResultSummary,
        AllResultList,
        PaginationTop,
        PaginationBottom,
        AllFacetContainer,
    },

    setup() {
        // *****************
        // Inject
        // *****************
        const {
            form,
            sort,
            per_page,
            page,
            hits,
            results,
            showResult,
            searchLoad,
            search,
            searchError,
            paramDefaults,
            searchInfoItems,
            searchParams,
            formRef,
            facetResetFlg,
        } = inject(SearchKey);

        /* キーワードランキングからの検索用 */
        const handleRankingSearch = (selectedKeyword) => {
            form.value.keyword = selectedKeyword;
            //パラメータのデフォルト値をセットする
            form.value.target_range = paramDefaults.target_range;
            form.value.sort = paramDefaults.sort;
            form.value.per_page = paramDefaults.per_page;
            form.value.page = paramDefaults.page;
            execSearch();
        };

        /* 検索結果 */
        //件数表示用
        const pageStart = () => {
            return (page.value - 1) * per_page.value + 1;
        };
        //ページネーションが必要な場合はtrue
        let withPagination = () => {
            return hits.value > per_page.value ? true : false;
        };
        let paginationPageEnd = () => {
            return page.value * per_page.value;
        };
        let currentPageEnd = withPagination
            ? page.value * per_page.value
            : hits.value;
        let resultSummaryPage = reactive({
            start: pageStart(),
            end: currentPageEnd,
        });
        //ページネーション用
        const changedPageSize = (size) => {
            per_page.value = size;
            watchSearch();
        };
        //ページ選択変更時処理
        //画面表示のリセットなしで再検索
        const changedCurrentPage = (current) => {
            if (page.value != current) {
                page.value = current;
                formRef.value.validate((valid) => {
                    if (valid) {
                        execSearch();
                    } else {
                        return false;
                    }
                });
            }
        };
        //表示順用
        const sortingItems = ref([
            {
                value: "created",
                label: "登録が新しい順に表示",
            },
            {
                value: "created-",
                label: "登録が古い順に表示",
            },
            {
                value: "dbname-",
                label: "データベース名の昇順で表示",
            },
            {
                value: "dbname",
                label: "データベース名の降順で表示",
            },
        ]);
        const changedSorting = (sorting) => {
            sort.value = sorting;
            watchSearch();
        };
        //検索実行
        const execSearch = async () => {
            await search();
        };

        // *****************
        // watch 関数宣言
        // *****************
        //検索結果概要（件数）表示の変更を反映させる
        watch([hits, page, per_page], () => {
            if (hits.value > 0) {
                resultSummaryPage.start = pageStart();
                currentPageEnd = paginationPageEnd();
                resultSummaryPage.end =
                    withPagination() && hits.value > currentPageEnd
                        ? currentPageEnd
                        : hits.value;
            }
        });
        //ページやソートの変更が発生した場合、検索をかける
        const watchSearch = () => {
            page.value = 1;
            formRef.value.validate((valid) => {
                if (valid) {
                    execSearch();
                } else {
                    return false;
                }
            });
        };
        return {
            /* 表示用 */
            searchInfoItems,
            resultSummaryPage,
            hits,
            page,
            results,
            showResult,
            searchLoad,
            searchError,
            facetResetFlg,
            per_page,
            sortingItems,
            sort,
            /* methods */
            // method:ランキング用
            handleRankingSearch,
            // methods:ページネーション用
            changedPageSize,
            changedCurrentPage,
            // method:ソート用
            changedSorting,
            searchParams,
        };
    },
});
</script>

<style scoped></style>
